// src/pages/PricingPage.js

import React, { useState, useEffect } from 'react';
import { Container, Form, Button, Alert, Table } from 'react-bootstrap';
import Header from '../components/Header';
import Navbar from '../components/Navbar';
import api from '../services/api';

export default function PricingPage({ setPage }) {
  const [form, setForm] = useState({ productId: '', storeId: '' });
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [records, setRecords] = useState([]);

  // Fetch historical pricing data on mount
  useEffect(() => {
    api
      .get('/pricing')
      .then((res) => setRecords(res.data))
      .catch(() => {});
  }, []);

  // Handle form input change
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Handle optimize button
  const handleOptimize = async () => {
    setError('');
    setResult(null);
    try {
      const payload = {
        productId: Number(form.productId),
        storeId: Number(form.storeId),
      };
      const { data } = await api.post('/pricing/optimize', payload);
      setResult(data);

      // Add result to records (optional local update)
      setRecords((prev) => [
        {
          productId: payload.productId,
          storeId: payload.storeId,
          elasticityIndex: data.elasticityIndex || '-',
          price: data.recommendedPrice,
        },
        ...prev,
      ]);
    } catch (err) {
      setError(err.response?.data?.error || 'Optimization failed');
    }
  };

  return (
    <Container className="card-transparent p-4">
      <Header />
      <Navbar setPage={setPage} />
      <h2>Pricing Optimization</h2>

      {error && <Alert variant="danger">{error}</Alert>}

      <Form className="mb-3">
        <Form.Control
          name="productId"
          placeholder="Product ID"
          value={form.productId}
          onChange={handleChange}
        />
        <Form.Control
          name="storeId"
          placeholder="Store ID"
          className="mt-2"
          value={form.storeId}
          onChange={handleChange}
        />
        <Button className="mt-2" onClick={handleOptimize}>
          Optimize
        </Button>
      </Form>

      {result && (
        <Alert variant="info">
          <strong>Current Price:</strong> {result.currentPrice}
          <br />
          <strong>Recommended Price:</strong> {result.recommendedPrice}
        </Alert>
      )}

      <h4 className="mt-4">Optimization History</h4>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Product ID</th>
            <th>Store ID</th>
            <th>Elasticity Index</th>
            <th>Recommended Price</th>
          </tr>
        </thead>
        <tbody>
          {records.map((p, index) => (
            <tr key={`${p.productId}-${p.storeId}-${index}`}>
              <td>{p.productId}</td>
              <td>{p.storeId}</td>
              <td>{p.elasticityIndex}</td>
              <td>{p.price}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
}
